import React, { useState } from 'react';
import Layout from '../components/Layout';
import { exportToPNG, copyToClipboard } from '../utils/exportUtils';
import '../styles/service-page.css';

const DiagramGenerator = ({ user }) => {
  const [description, setDescription] = useState('');
  const [diagramType, setDiagramType] = useState('sequence');
  const [generatedDiagram, setGeneratedDiagram] = useState('');

  const handleGenerate = () => {
    // Placeholder for diagram generation logic
    const placeholder = `@startuml
title ${diagramType.charAt(0).toUpperCase() + diagramType.slice(1)} Diagram
note as N1
  Generated from: "${description}"
end note
@enduml`;
    setGeneratedDiagram(placeholder);
  };

  return (
    <Layout>
      <div className="container service-page">
        <div className="page-heading">
          <h1>AI-Powered Diagram Generator</h1>
          <p>Transform your plain language descriptions into professional diagrams instantly. Describe your system, process, or architecture, and watch as our AI creates clean, standards-based diagrams.</p>
        </div>

        <div className="service-content">
          <div className="generator-section">
            <h2>Generate Your Diagram</h2>
            <div className="input-group">
              <label htmlFor="diagramType">Diagram Type:</label>
              <select 
                id="diagramType" 
                value={diagramType} 
                onChange={(e) => setDiagramType(e.target.value)}
                className="form-select"
              >
                <option value="sequence">Sequence Diagram</option>
                <option value="class">Class Diagram</option>
                <option value="component">Component Diagram</option>
                <option value="deployment">Deployment Diagram</option>
                <option value="flowchart">Flowchart</option>
                <option value="er">Entity Relationship</option>
              </select>
            </div>
            
            <div className="input-group">
              <label htmlFor="description">Describe your diagram:</label>
              <textarea
                id="description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Example: A user authentication system where a user logs in through a web interface, the system validates credentials against a database, and returns a JWT token..."
                rows="6"
                className="form-textarea"
              />
            </div>
            
            <button onClick={handleGenerate} className="generate-button">
              Generate Diagram
            </button>
          </div>

          {generatedDiagram && (
            <div className="result-section">
              <h3>Generated Diagram Code</h3>
              <pre className="code-output">
                <code>{generatedDiagram}</code>
              </pre>
              <div className="action-buttons">
                <button 
                  className="copy-button"
                  onClick={() => copyToClipboard(generatedDiagram)}
                >
                  Copy Code
                </button>
                <button 
                  className="download-button"
                  onClick={() => exportToPNG(generatedDiagram, diagramType)}
                >
                  Download PNG
                </button>
              </div>
            </div>
          )}

          <div className="features-section">
            <h2>Key Features</h2>
            <div className="features-grid">
              <div className="feature-item">
                <h3>Natural Language Processing</h3>
                <p>Describe your diagrams in plain English. Our AI understands technical concepts and relationships.</p>
              </div>
              <div className="feature-item">
                <h3>Multiple Diagram Types</h3>
                <p>Support for sequence, class, component, deployment, flowchart, and ER diagrams.</p>
              </div>
              <div className="feature-item">
                <h3>Standards-Based Output</h3>
                <p>Generates clean PlantUML and Mermaid code that follows industry best practices.</p>
              </div>
              <div className="feature-item">
                <h3>Instant Results</h3>
                <p>Get professional diagrams in seconds, not hours. Perfect for rapid prototyping and documentation.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default DiagramGenerator;